var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentProfileActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#B4A085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7751 27.7645L15.6851 27.6745C15.2951 27.2845 15.2951 26.6545 15.6851 26.2645L21.7751 20.1645C22.1651 19.7745 22.7951 19.7745 23.1851 20.1645L26.4751 23.4545L32.8651 16.2745C33.2451 15.8445 33.9151 15.8345 34.3151 16.2345C34.6851 16.6145 34.7051 17.2145 34.3551 17.6045L27.1851 25.6745C26.8051 26.1045 26.1451 26.1245 25.7351 25.7145L22.4851 22.4645L17.1851 27.7645C16.8051 28.1545 16.1651 28.1545 15.7751 27.7645ZM17.1851 33.7645L22.4851 28.4645L25.7351 31.7145C26.1451 32.1245 26.8051 32.1045 27.1851 31.6745L34.3551 23.6045C34.7051 23.2145 34.6851 22.6145 34.3151 22.2345C33.9151 21.8345 33.2451 21.8445 32.8651 22.2745L26.4751 29.4545L23.1851 26.1645C22.7951 25.7745 22.1651 25.7745 21.7751 26.1645L15.6851 32.2645C15.2951 32.6545 15.2951 33.2845 15.6851 33.6745L15.7751 33.7645C16.1651 34.1545 16.8051 34.1545 17.1851 33.7645Z",
    fill: "#B4A085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentProfileActiveIcon);
export default __webpack_public_path__ + "static/media/investment_profile_active_icon.22e620fef58d4aa0f4c8036383aaf5c5.svg";
export { ForwardRef as ReactComponent };